// components/EditableScoreCell.js
import React, { useState } from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  ActivityIndicator
} from 'react-native';
import ScorePickerModal from './ScorePickerModal';
import hapticService from '../services/hapticService';

const EditableScoreCell = ({ 
  value, 
  position,
  isModified,
  isOriginal,
  isSyncing,
  onValueChange,
  disabled = false
}) => {
  const [showPicker, setShowPicker] = useState(false);

  const handleCellPress = () => {
    if (disabled || isSyncing) return;
    
    hapticService.selection();
    setShowPicker(true);
  };

  const handleValueSelect = async (newValue) => {
    setShowPicker(false);
    
    if (newValue !== value) {
      await onValueChange(newValue);
    }
  };

  const handleCancel = () => {
    hapticService.button();
    setShowPicker(false);
  };

  const getCellStyle = () => {
    let baseStyle = [styles.cell];
    
    if (disabled) {
      baseStyle.push(styles.cellDisabled);
    } else if (isSyncing) {
      baseStyle.push(styles.cellSyncing);
    } else if (isModified) {
      baseStyle.push(styles.cellModified);
    } else if (isOriginal && value && value !== '-') {
      baseStyle.push(styles.cellOriginal);
    } else if (!value || value === '-') {
      baseStyle.push(styles.cellEmpty);
    } else {
      baseStyle.push(styles.cellNormal);
    }
    
    return baseStyle;
  };

  const getTextStyle = () => {
    let baseStyle = [styles.cellText];
    
    if (disabled) {
      baseStyle.push(styles.cellTextDisabled);
    } else if (isModified) {
      baseStyle.push(styles.cellTextModified);
    } else if (!value || value === '-') {
      baseStyle.push(styles.cellTextEmpty);
    }
    
    return baseStyle;
  };

  return (
    <View style={styles.container}>
      <TouchableOpacity
        style={getCellStyle()}
        onPress={handleCellPress}
        disabled={disabled || isSyncing}
        activeOpacity={0.7}
      >
        {isSyncing ? (
          <ActivityIndicator size="small" color="#0066cc" />
        ) : (
          <Text style={getTextStyle()}>
            {value || '-'}
          </Text>
        )}
        
        {/* Indicateur de modification */}
        {isModified && !isSyncing && (
          <View style={styles.modifiedIndicator} />
        )}
      </TouchableOpacity>
      
      <ScorePickerModal
        visible={showPicker}
        currentValue={value}
        position={position}
        onSelect={handleValueSelect}
        onCancel={handleCancel}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    width: '100%',
    height: 45,
    flex: 1,
  },
  cell: {
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: 4,
  },
  cellNormal: {
    backgroundColor: '#fff',
  },
  cellEmpty: {
    backgroundColor: '#e8e8e8',
  },
  cellOriginal: {
    backgroundColor: '#ddeeff',
  },
  cellModified: {
    backgroundColor: '#fff3e0',
    borderColor: '#ff9800',
    borderWidth: 2,
  },
  cellSyncing: {
    backgroundColor: '#e3f2fd',
    borderColor: '#0066cc',
    borderWidth: 1,
  },
  cellDisabled: {
    backgroundColor: '#f5f5f5',
    borderColor: '#e0e0e0',
    opacity: 0.6,
  },
  cellText: {
    fontSize: 16,
    
    fontFamily: 'Montserrat_700Bold',
    color: '#333',
  },
  cellTextEmpty: {
    color: '#999',
  },
  cellTextModified: {
    color: '#f57c00',
  },
  cellTextDisabled: {
    color: '#999',
  },
  modifiedIndicator: {
    position: 'absolute',
    top: 2,
    right: 2,
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: '#ff9800',
  },
});

export default EditableScoreCell;